import React from "react";
import { Tooltip, Typography } from "antd";
import _ from "lodash";
import { getStaticAssetPath } from "../utils/utils";

const DefaultBadge = "images/ic_award.svg";

const { Paragraph } = Typography;

interface Props {
  awardList: any[];
  mode: number;
  PreviewMode: any;
}

type MatchResult = { match: { id: number|null; name: string; url?: string|null; width: number; logo: string } | null; line?: string };
const getAwardLogo = (match: MatchResult | undefined) => {
  const width = (match?.match?.width ?? 100) + 'px'
  const src = match?.match?.logo ? match.match.logo : getStaticAssetPath("images/ic_award.svg")
  const img = <img alt={'Award'} style={{ width }} src={src} />
  return match?.match?.url ? (
    <a href={match.match.url as string} target="_blank" rel="noopener noreferrer">{img}</a>
  ) : img
}

const getAwardText = (data: any): string => {
  if (typeof data === "number") return "Issue Year - Issuer";
  if (data.issueYear && data.issuer) return `${data.issueYear} - ${data.issuer}`;
  return data.issueYear || data.issuer || "";
};

const getItemText = (item: { title?: string } = {}): string => {
  const title = item.title ?? "Title";
  return title.startsWith("Head UP Mental Health -") ? "Head UP Mental Health" : title;
};

const CanvasAwards: React.FC<Props> = ({ awardList, mode, PreviewMode }) => {
  const isEmpty = _.isEmpty(awardList) && mode !== PreviewMode.CREATE;
  const items = !_.isEmpty(awardList) ? awardList : [0, 1, 2, 3];
  const [matches, setMatches] = React.useState<MatchResult[]>([]);
  React.useEffect(() => {
    const awards = Array.isArray(awardList)
      ? awardList.filter((a: any) => a && (a.title || a.issuer || a.issueYear))
      : []
    if (!awards.length) {
      setMatches([])
      return
    }
    fetch(`${process.env.REACT_APP_NEXT_URL}/api/badges/match`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ awards }) })
      .then((r) => r.ok ? r.json() : Promise.reject())
      .then((j) => setMatches(Array.isArray(j?.matches) ? j.matches : []))
      .catch(() => setMatches([]));
  }, [awardList]);

  return (
    <div className="awards-sec" hidden={isEmpty} id="awards">
      <span className="canvas-title">Awards and Achievements</span>
      <div className="awards-list">
        {items.map((item, idx) => {
          const isRedken = item?.title?.includes("Redken Safe Space Educated");

          const content = (
            <>
              {getAwardLogo(matches[idx])}
              <Tooltip title={getItemText(item)}>
                <Paragraph className="title">{getItemText(item)}</Paragraph>
              </Tooltip>
              <Tooltip title={matches[idx]?.line ?? getAwardText(item)}>
                <Paragraph ellipsis={{ rows: 1, expandable: true }} className="issue">
                  {matches[idx]?.line ?? getAwardText(item)}
                </Paragraph>
              </Tooltip>
            </>
          );

          return (
            <div className="awards-item-empty" key={idx}>
              {isRedken ? (
                <a
                  href="https://u.canvasme.com/course/safe-space/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {content}
                </a>
              ) : (
                content
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CanvasAwards;
